import { render, staticRenderFns } from "./CostItem.vue?vue&type=template&id=107e6492"
import script from "./CostItem.vue?vue&type=script&lang=js"
export * from "./CostItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports